var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var BookmarkController = /** @class */ (function () {
    function BookmarkController() {
    }
    /*****************************************************************************************************
        * Is using route "api/bookmark" and http method "GET" to call the back-end.
    
        * @returns {BookmarksDownloadDto}
    ******************************************************************************************************/
    BookmarkController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/bookmark", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/bookmark" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<BookmarkDownloadDto, string>}
    ******************************************************************************************************/
    BookmarkController.GetPaged = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/bookmark", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/bookmark/paged" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<BookmarkDownloadDto, string>}
    ******************************************************************************************************/
    BookmarkController.GetPagedFiltered = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/bookmark/paged", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/bookmark/{postid}" and http method "POST" to call the back-end.
    
        * @param {string} postid
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    BookmarkController.PostBookmark = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/bookmark/{postid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/bookmark/{postid}" and http method "DELETE" to call the back-end.
    
        * @param {string} postid
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    BookmarkController.RemoveBookmark = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/bookmark/{postid}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return BookmarkController;
}());
export { BookmarkController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=BookmarkController.js.map